import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';

// Motif obligatoire (5 caractères min.) pour une rectification tracée
export const RectifyDialog = ({ report, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');
  const valid = reason.trim().length >= 5;
  return (
    <Dialog open={!!report} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="rc-rectify-dialog">
        <DialogHeader>
          <DialogTitle>Rectifier le bulletin</DialogTitle>
          <DialogDescription>
            La version actuelle de {report?.student_name} sera archivée (conservée telle quelle), puis vous pourrez régénérer et faire revalider le bulletin.
          </DialogDescription>
        </DialogHeader>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Motif de la rectification" data-testid="rc-rectify-reason" />
        {!valid && reason.length > 0 && <p className="text-xs text-red-600">5 caractères minimum</p>}
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Annuler</Button>
          <Button disabled={!valid} onClick={() => onConfirm(reason.trim())} data-testid="rc-rectify-confirm">Archiver et rectifier</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
